// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failure-container {
  background-color: #ebebeb;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.failure-icon {
  width: 80px;
  height: 80px;
  background-color: #f44336;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
}

.failure-icon i {
  color: white;
  font-size: 40px;
}

.failedTxt {
  color: #f44336;
  margin-bottom: 15px;
  font-size: 28px;
}

.pay-failed-text {
  color: #555;
  margin-bottom: 25px;
  line-height: 1.6;
}

.error-details {
  background-color: #fef2f2;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  border-left: 4px solid #f44336;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #777;
}

.detail-value {
  color: #333;
  font-weight: 500;
}

.btn-group {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.btn {
  display: inline-block;
  text-decoration: none;
  padding: 12px 30px;
  border-radius: 5px;
  font-weight: bold;
  /* transition: all 0.3s; */
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.btn-retry {
  background-color: #f44336;
  color: white;
}

.btn-retry:hover {
  background-color: #d32f2f;
}

.btn-alternate {
  background-color: white !important;
  color: #f44336;
  border: 1px solid #f44336;
}

.btn-alternate:hover {
  background-color: #fdeaea !important;
}

.support-note {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  color: #666;
  font-size: 14px;
}

.support-note i {
  color: #f44336;
  margin-right: 8px;
}

@media (max-width: 480px) {
  .btn-group {
    flex-direction: column;
  }

  .failure-container {
    padding: 30px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/general/paymentFailed/PaymentFailed.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".failure-container {\n  background-color: #ebebeb;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n}\n\n.failure-icon {\n  width: 80px;\n  height: 80px;\n  background-color: #f44336;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 20px;\n}\n\n.failure-icon i {\n  color: white;\n  font-size: 40px;\n}\n\n.failedTxt {\n  color: #f44336;\n  margin-bottom: 15px;\n  font-size: 28px;\n}\n\n.pay-failed-text {\n  color: #555;\n  margin-bottom: 25px;\n  line-height: 1.6;\n}\n\n.error-details {\n  background-color: #fef2f2;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  text-align: left;\n  border-left: 4px solid #f44336;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.detail-label {\n  color: #777;\n}\n\n.detail-value {\n  color: #333;\n  font-weight: 500;\n}\n\n.btn-group {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.btn {\n  display: inline-block;\n  text-decoration: none;\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-weight: bold;\n  /* transition: all 0.3s; */\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.btn-retry {\n  background-color: #f44336;\n  color: white;\n}\n\n.btn-retry:hover {\n  background-color: #d32f2f;\n}\n\n.btn-alternate {\n  background-color: white !important;\n  color: #f44336;\n  border: 1px solid #f44336;\n}\n\n.btn-alternate:hover {\n  background-color: #fdeaea !important;\n}\n\n.support-note {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 25px;\n  color: #666;\n  font-size: 14px;\n}\n\n.support-note i {\n  color: #f44336;\n  margin-right: 8px;\n}\n\n@media (max-width: 480px) {\n  .btn-group {\n    flex-direction: column;\n  }\n\n  .failure-container {\n    padding: 30px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
